import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type AthleteEventDelete = {
  athleteEventId: string;
  type: string;
};

type AthleteEventsDelete = {
  athleteEvents: Array<AthleteEventDelete>;
};

export default function useDeleteAthleteEvents(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  { data: AthleteEventsDelete }
> {
  const queryClient = useQueryClient();

  const deleteAthleteEvents = (athleteEvents: {
    data: AthleteEventsDelete;
  }): Promise<AxiosResponse<null>> => {
    return client.delete('athlete-events/delete-bulk/', athleteEvents);
  };

  return useMutation(deleteAthleteEvents, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['athleteEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['appointments'],
      });
      queryClient.invalidateQueries({
        queryKey: 'events',
      });
      queryClient.invalidateQueries({
        queryKey: ['totalAttended'],
      });
      queryClient.invalidateQueries({
        queryKey: ['totalReserved'],
      });
    },
  });
}
